import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth, useAuthStatus } from '../../../contexts/AuthContext';
import styles from './Header.module.css';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const { isAuthenticated } = useAuthStatus();

  // Environment detection for staging indicator
  const getEnvironment = () => {
    const hostname = window.location.hostname;
    
    if (hostname.includes('staging-book.cybermed.ai') || hostname.includes('staging') || hostname.includes('preview')) {
      return 'staging';
    } else if (hostname === 'book.cybermed.ai') {
      return 'production';
    } else if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'development';
    } else {
      return 'production';
    }
  };

  const environment = getEnvironment();

  return (
    <header className={styles.header}>
      {environment === 'staging' && (
        <div className={styles.stagingBanner}>
          🚧 STAGING ENVIRONMENT - Test data only
        </div>
      )}
      {environment === 'development' && (
        <div className={styles.developmentBanner}>
          🔧 DEVELOPMENT ENVIRONMENT
        </div>
      )}
      <div className={styles.mobileCallBanner}>
        <a 
          href="https://cybermed.ai/jb30" 
          target="_blank" 
          rel="noopener noreferrer"
          className={styles.mobileCallLink}
        >
           Schedule a Call with the Authors
        </a>
      </div>
      <div className={styles.headerContent}>
        <a 
          href="https://cybermed.ai" 
          target="_blank" 
          rel="noopener noreferrer" 
          className={styles.logo}
        >
          <img 
            src="/images/branding/cybermed-logo.webp" 
            alt="CyberMed Logo" 
            className={styles.logoImage}
          />
        </a>
        
        <div className={styles.centerSection}>
          <a
            href="https://cybermed.ai/jb30"
            target="_blank"
            rel="noopener noreferrer"
            className={`btn btn-primary ${styles.scheduleCallBtn}`}
          >
            <span className={styles.buttonTextDesktop}>
              Schedule a Call with the Authors
            </span>
            <span className={styles.buttonTextMobile}>
              Schedule<br />a Call
            </span>
          </a>
        </div>
        
        <nav className={styles.nav}>
          {isAuthenticated ? (
            <div className={styles.navAuthenticated}>
              <div className={styles.userMenu}>
                <span className={styles.userName}>
                  {user?.firstName} {user?.lastName}
                </span>
                <button onClick={logout} className={`btn btn-outline ${styles.btnSm}`}>
                  Sign Out
                </button>
              </div>
            </div>
          ) : (
            <div className={styles.navGuest}>
              <Link to="/login" className={styles.navLink}>
                Sign In
              </Link>
              <Link to="/register" className={`btn btn-primary ${styles.btnSm}`}>
                Get Access
              </Link>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
